<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        yAxis: { type: "category", data: ["Morning", "Afternoon", "Evening"] },
        visualMap: {
          min: 0,
          max: 10,
          calculable: true,
          orient: "horizontal",
          left: "center",
          bottom: "15%"
        },
        series: [
          {
            type: "heatmap",
            data: [
              [0, 0, 5],
              [1, 0, 1],
              [2, 0, 9],
              [3, 0, 3],
              [4, 0, 2],
              [5, 0, 7],
              [6, 0, 8],
              [0, 1, 4],
              [1, 1, 2],
              [2, 1, 5],
              [3, 1, 6],
              [4, 1, 3],
              [5, 1, 1],
              [6, 1, 2],
              [0, 2, 7],
              [1, 2, 3],
              [2, 2, 2],
              [3, 2, 1],
              [4, 2, 4],
              [5, 2, 8],
              [6, 2, 6]
            ]
          }
        ]
      }
    };
  }
};
</script>
